/* eslint-disable @next/next/no-img-element */
import React from 'react';
import SpinnerSVG from '../assets/svgs/spinner.svg';

export const Spinner: React.FC<{ visible?: boolean }> = ({ visible = false }) => {
    return visible ? (
        <img src={SpinnerSVG.src} className="animate-spin" alt="loading" width={44} height={44} />
    ) : null;
};
